import { useEffect } from 'react';

export const useIframePositioning = ({
                                         isWidgetShown,
                                         isSmallScreen,
                                         position,
                                         radius,
                                         margins,
                                         cW = 360,
                                         cH = 600,
                                         bntSize = 64,
                                     }) => {
    useEffect(() => {
        const iframe = window.parent?.document?.getElementById('chat-widget');
        if (!iframe) return;

        const body = window.parent?.document?.body;
        const [oW, oH] = Array.isArray(margins) ? margins : [10, 10];

        const setIframeStyles = (styles) => {
            Object.entries(styles).forEach(([key, value]) => {
                iframe.style.setProperty(key, value);
            });
        };

        const setIframePosition = (top, right, bottom, left) => {
            setIframeStyles({
                top: top !== null ? `${top}px` : '',
                right: right !== null ? `${right}px` : '',
                bottom: bottom !== null ? `${bottom}px` : '',
                left: left !== null ? `${left}px` : '',
            });
        };

        requestAnimationFrame(() => {
            if (!isWidgetShown) {
                setIframeStyles({
                    'max-width': isSmallScreen ? '100%' : `${cW}px`,
                    'max-height': isSmallScreen ? '100%' : `${cH}px`,
                    'box-shadow': '0px 0px 30px 0px rgba(0, 0, 0, 0.10)',
                    'border-radius': isSmallScreen ? '0' : `${radius}px`,
                });
                body.style.overflow = isSmallScreen ? 'hidden' : '';
            } else {
                setIframeStyles({
                    'max-width': `${bntSize}px`,
                    'max-height': `${bntSize}px`,
                    'box-shadow': 'none',
                });
                body.style.overflow = '';
            }

            const setPosition = (top, right, bottom, left) => setIframePosition(top, right, bottom, left);

            const positionMap = {
                'top-left': () => setPosition(oW, null, null, oH),
                'top-right': () => setPosition(oW, oH, null, null),
                'bottom-left': () => setPosition(null, null, oW, oH),
                'bottom-right': () => setPosition(null, oH, oW, null),
                'default': () => setPosition(null, oH, oW, null),
            };

            if (isSmallScreen && !isWidgetShown) {
                return setPosition(null, null, 0, 0);
            }

            (positionMap[position] || positionMap.default)();
        });
    }, [isWidgetShown, isSmallScreen, position, radius, margins, cW, cH, bntSize]);
};
